import axios from "axios";

export const uploadDocument = async ({
  file,
  projectCode,
  envCode,
  folderPath,
}) => {
  if (!file) throw new Error("File is required");
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  if (!dbTokenData) throw new Error("Authorization token missing");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("projectCode", projectCode);
  formData.append("envCode", envCode);
  formData.append("folderPath", folderPath);

  const res = await axios.post(`${apiUrl}documents/upload`, formData, {
    headers: {
      Authorization: `Bearer ${dbTokenData}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const viewDocument = async ({
  projectCode,
  envCode,
  folderPath,
  fileName,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  if (!dbTokenData) throw new Error("Authorization token missing");
  const res = await axios.post(
    `${apiUrl}documents/view`,
    { projectCode, envCode, folderPath, fileName },
    {
      headers: {
        Authorization: `Bearer ${dbTokenData}`,
      },
    },
  );

  return res.data;
};

export const deleteDocument = async ({
  projectCode,
  envCode,
  folderPath,
  fileName,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  if (!dbTokenData) throw new Error("Authorization token missing");
  const res = await axios.post(
    `${apiUrl}documents/delete`,
    { projectCode, envCode, folderPath, fileName },
    {
      headers: {
        Authorization: `Bearer ${dbTokenData}`,
      },
    },
  );
  return res.data;
};

export const getMimeType = (fileName) => {
  const ext = fileName.split(".").pop().toLowerCase();

  switch (ext) {
    case "png":
      return "image/png";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "pdf":
      return "application/pdf";
    default:
      return "image/png";
  }
};
